var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apollo-query',{attrs:{"query":_vm.centerQuery,"variables":{"id": _vm.centerCodeOrId, "code": _vm.centerCodeOrId}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_result = ref.result;
var loading = ref_result.loading;
var error = ref_result.error;
var data = ref_result.data;
return [(loading)?_c('div',[_vm._v("Page is loading")]):(error)?_c('div',[_vm._v(_vm._s(error))]):(data)?_c('div',[_c('div',[_vm._v(_vm._s(JSON.stringify(data.center)))])]):_c('div',{staticClass:"no-result apollo"},[_vm._v("No result :(")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }